import * as z from 'zod';
import { QuestionsDetail } from '../pages/steps/questions/questions-detail';

// TODO: ideally we would do this at build time.
export function makeQuestionBuilder(pathPrefix, progressPrefix, translationNamespace) {
  return (step) => {
    const props = { ...step.props };
    const name = props.name;
    const path = `${pathPrefix}-${name.replaceAll(/[a-z0-9][A-Z]/g, (x) => `${x[0]}-${x[1].toLowerCase()}`)}`;
    const progressKey = `${progressPrefix}${name[0].toUpperCase()}${name.slice(1)}`;

    props.translationNamespace = translationNamespace;
    props.translationKey = `questions.${props.name.replaceAll(/-[a-z]/g, (x) => x[1].toUpperCase())}`;

    const schema = z.union([
      z.object({
        primary: z.literal('no'),
      }),
      z
        .object({
          primary: z.string().trim().min(2),
          secondary: z.string(),
          details: props.details ? z.string().trim().min(1) : z.literal(''),
        })
        .superRefine(({ primary, secondary }, context) => {
          const hasSecondaryOptions = Object.hasOwn(props.secondaryOptions ?? {}, primary);
          if (hasSecondaryOptions && secondary.trim().length === 0) {
            context.addIssue({ code: 'too_small', message: 'Required', path: ['secondary'] });
          }
        }),
    ]);

    const extractDefaults = (progress) => {
      const current = progress[progressKey];
      return {
        primary: current?.primary ?? '',
        secondary: current?.secondary ?? '',
        details: current?.details ?? '',
      };
    };

    const transformValues = ({ primary, secondary, details }) => {
      const values = { primary };
      if (secondary) {
        values.secondary = secondary;
      }
      if (details) {
        values.details = details;
      }
      return { [progressKey]: values };
    };

    const answer = (progress) => progress[progressKey];

    return {
      path,
      component: (props) => (
        <QuestionsDetail
          {...props}
          key={path}
          extractDefaults={extractDefaults}
          transformValues={transformValues}
          schema={schema}
        />
      ),
      answer,
      done: (progress) => !!answer(progress),
      nextLabel: `${translationNamespace}:questions.${name}.nextLabel`,
      ...step,
      props,
    };
  };
}
